import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { useQuery } from "@apollo/client";

import soilmoistureQuery from "./soilmoisture-overview-query";

import TrendGraphContainer from "../trend-graph-container";

import { trendDurationVar } from "../../../reactive-variables";
import { useReactiveQueryParam } from "../../../use-reactive-query-params";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dateSelect: {
      cursor: "pointer",
    },
  })
);

function SoilmoistureOverviewPanelContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
  } = props;
  const classes = useStyles(props);
  const trendDurationReactiveVar = useReactiveQueryParam(
    "trendduration",
    trendDurationVar
  );
  const n = nodes ? nodes.join(",") : undefined;

  const { data, error, loading } = useQuery(soilmoistureQuery, {
    variables: {
      panelCollectionName: panelCollectionName,
      panelName: panelDefinition?.template,
      tab: panelDefinition?.id,
      node: n,
    },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  return (
    <>
      <Grid container item xs={12} spacing={1} justify="space-evenly">
        {data.timeIntervals.map((timeInterval: any) => (
          <Typography
            key={timeInterval.duration}
            variant="h5"
            className={classes.dateSelect}
            onClick={() => {
              trendDurationVar(timeInterval.duration);
            }}
            style={{
              fontWeight:
                timeInterval.duration === trendDurationVar()
                  ? "bold"
                  : undefined,
            }}
          >
            {timeInterval.label}
          </Typography>
        ))}
      </Grid>
      <Grid container spacing={1} justify="center" alignItems="center">
        {!!data.soilmoistureOverview.showAvg && (
          <Grid item xs={12}>
            <TrendGraphContainer
              nodes={nodes}
              panelCollectionName={panelCollectionName}
              // panelName={panelName} // TODO
              panelDefinition={panelDefinition}
              // startDate={moment().startOf("day").unix()}
              // endDate={moment().endOf("day").unix()}
              metaData={{
                options: data.soilmoistureOverview.optionsAvg,
                allData: data.soilmoistureOverview.allDataAvg,
              }}
            />
          </Grid>
        )}
        {!!data.soilmoistureOverview.showSum && (
          <Grid item xs={12}>
            <TrendGraphContainer
              nodes={nodes}
              panelCollectionName={panelCollectionName}
              // panelName={panelName} // TODO
              panelDefinition={panelDefinition}
              // startDate={moment().startOf("day").unix()}
              // endDate={moment().endOf("day").unix()}
              metaData={{
                options: data.soilmoistureOverview.optionsSum,
                allData: data.soilmoistureOverview.allDataAvg,
              }}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default SoilmoistureOverviewPanelContainer;
